import { render, staticRenderFns } from "./Convert.vue?vue&type=template&id=5bf36806&scoped=true&"
import script from "./Convert.vue?vue&type=script&lang=js&"
export * from "./Convert.vue?vue&type=script&lang=js&"
import style0 from "./Convert.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Convert.vue?vue&type=style&index=1&id=5bf36806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf36806",
  null
  
)

export default component.exports